var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArSlotGuest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7646",
    "data-name": "Group 7646",
    transform: "translate(12748 -10210)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_22123",
    "data-name": "Ellipse 22123",
    transform: "translate(-12748 10210)",
    fill: "#fff",
    stroke: "#4f5b6d",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5239",
    "data-name": "Path 5239",
    d: "M8,12.852a5,5,0,0,1-4.527-7.1A4.852,4.852,0,0,1,7.992,2.91h0a4.7,4.7,0,0,1,3.022,1.018,1.083,1.083,0,0,1-.076,1.43,1.083,1.083,0,0,1-1.245.076,2.892,2.892,0,0,0-1.7-.52,2.924,2.924,0,0,0-2.9,2.935v.087A2.935,2.935,0,0,0,8,10.848H8A2.372,2.372,0,0,0,10.4,9.3H8.479a.866.866,0,0,1-.834-.823.823.823,0,0,1,.823-.845H12.1c.477,0,.661.249.606.769C12.367,11.487,10.58,12.852,8,12.852Z",
    transform: "translate(-12747.963 10210.091)",
    fill: "#4f5b6d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArSlotGuest);
export default __webpack_public_path__ + "static/media/ar-slot-guest.184634b0e1d60bdb29f6545bb0efa9f9.svg";
export { ForwardRef as ReactComponent };